import {IconPlus} from '@tabler/icons-react';
import {Button} from 'src/design/atoms/Button';
import type {ButtonProps} from 'src/design/atoms/Button';

/**
 * "Create"/"Add New" button — thin `Button` wrapper with a plus icon,
 * `variant="filled"`, `color="yellow"`, `size="md"`, defaulting its label
 * to "Add New".
 * @registry Primary "add new record" action button.
 *
 * Ported from `library-m/components/buttons/CreateButton`. Prop surface
 * kept identical (all `Button` props pass through, `children` defaults to
 * "Add New" but can still be overridden).
 */
export type CreateButtonProps = ButtonProps;

export const CreateButton = ({
  variant = 'filled',
  color = 'yellow',
  size = 'md',
  leftSection = <IconPlus />,
  children = 'Add New',
  ...props
}: CreateButtonProps) => (
  <Button
    variant={variant}
    color={color}
    size={size}
    leftSection={leftSection}
    {...props}>
    {children}
  </Button>
);
